// The flag arrives as a boolean, a number or a string depending on the payload.
const ADMIN_BLOCKED_VALUES = [true, 1, '1'];

/**
 * Whether an account is blocked by an admin, whatever type the flag arrives in.
 *
 * @param {boolean|number|string} isAdminBlocked Flag from the roster or a group participant.
 * @returns {boolean} True when the account is blocked.
 */
export const isAdminBlockedFlag = isAdminBlocked => ADMIN_BLOCKED_VALUES.includes(isAdminBlocked);
